import { render, staticRenderFns } from "./AreasList.vue?vue&type=template&id=b2ef2cf6&scoped=true"
import script from "./AreasList.vue?vue&type=script&lang=js"
export * from "./AreasList.vue?vue&type=script&lang=js"
import style0 from "./AreasList.vue?vue&type=style&index=0&id=b2ef2cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ef2cf6",
  null
  
)

export default component.exports